'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.getDisplayName = getDisplayName;
exports.getDataDependency = getDataDependency;
exports.getProps = getProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Find the name to display for a given component
 * Taken from react-redux.
 *
 * @param ReactClass<*> WrappedComponent
 * @return String
 */
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * Check wether a routeable component defines `methodName`.
 * Check recursively until method is implemented OR
 * the component does not define a WrappedComponent property.
 */
function getDataDependency() {
  var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var methodName = arguments[1];

  if (typeof component[methodName] === 'function') {
    return component[methodName];
  }

  if (component.WrappedComponent) {
    return getDataDependency(component.WrappedComponent, methodName);
  }

  return null;
}

/**
 * Return the props and extraProps merged or extraProps namespaced.
 * Useful to separate components own props and decorators injected props.
 */
function getProps(props, extraProps, propsNamespace) {
  var finalProps = void 0;

  if (!propsNamespace) {
    finalProps = (0, _extends4.default)({}, props, extraProps);
  } else {
    finalProps = (0, _extends4.default)({}, props, (0, _defineProperty3.default)({}, propsNamespace, (0, _extends4.default)({}, extraProps)));
  }

  return finalProps;
}


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/react/component-helper.js
// module id = 251
// module chunks = 0